// Adminsaccountcreationpage.js
import React, { useState,useEffect } from 'react';
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Grid,
  Paper,
  FormControlLabel,
  Checkbox,
  Alert,
  CircularProgress,
  Snackbar,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { Visibility, VisibilityOff, LocationOn } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { createaccountsfromadminaccount } from '../../../services/AuthServices';

// Common country codes
const COUNTRY_CODES = [
  { code: '+91', country: 'India' },
  { code: '+1', country: 'USA/Canada' },  
  

];

const AdminsAccountCreationPage = ({providers}) => {
    
    const PROVIDER_TYPES = providers
  .filter(provider => {
    const typeLower = provider.type.toLowerCase();
    // Filter out system roles
    
    return typeLower
  })
  .reduce((acc, provider) => {
    // Create a key from the type (convert to uppercase and replace spaces with underscores)
    const key = provider.type.toUpperCase().replace(/\s+/g, '_');
    acc[key] = {
      id: provider.id,
      type: provider.type.toLowerCase(), // lowercase for consistency
      label: provider.type, // Use the type as label
      // Add other properties if needed
      description: provider.description || '',
      serviceName: provider.serviceName || '',
      isActive: provider.isActive || true
    };
    return acc;
  }, {});


  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Form state
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    password: '',
    confirmPassword: '',
    providerTypeIds: [],
    countryCode: '+1',
    address: {
      street: '',
      city: '',
      state: '',
      postalCode: '',
      latitude: '',
      longitude: '',
    },
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  // TODO: Uncomment and implement API calls
  
  
  useEffect(() => {
    const fetchProviderTypes = async () => {
      try {
        
        
        const response = await fetch('/api/provider-types');
        const data = await response.json();
        // Set provider types from API response
      } catch (error) {
        console.error('Error fetching provider types:', error);
      }
    };
    fetchProviderTypes();
  }, []);
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
      if (name === 'mobileNumber') {
    // Remove all non-digit characters
    const numbersOnly = value.replace(/\D/g, '');
    // Limit to 10 digits
    const truncatedValue = numbersOnly.slice(0, 10);
    
    setFormData((prev) => ({
      ...prev,
      [name]: truncatedValue,
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      address: {
        ...prev.address,
        [name]: value,
      },
    }));
  };



  const validateForm = () => {
    const newErrors = {};

    // Required fields validation
    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!formData.mobileNumber.trim()) newErrors.mobileNumber = 'Mobile number is required';
    if (!formData.password) newErrors.password = 'Password is required';
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }
    if (formData.providerTypeIds.length === 0) {
      newErrors.providerTypeIds = 'At least one provider type is required';
    }
    if (!formData.countryCode) newErrors.countryCode = 'Country code is required';

    // Email validation (optional but must be valid if provided)
    if (formData.email && !/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    // Address validation
    if (!formData.address.latitude || !formData.address.longitude) {
      newErrors.address = 'Latitude and longitude are required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      setLoading(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setFormData((prev) => ({
            ...prev,
            address: {
              ...prev.address,
              latitude: position.coords.latitude.toString(),
              longitude: position.coords.longitude.toString(),
            },
          }));
          setLoading(false);
        },
        (error) => {
          console.error('Error getting location:', error);
          setSnackbar({
            open: true,
            message: 'Failed to get location. Please enter manually.',
            severity: 'error',
          });
          setLoading(false);
        }
      );
    } else {
      setSnackbar({
        open: true,
        message: 'Geolocation is not supported by your browser',
        severity: 'error',
      });
    }
  };



  const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (!validateForm()) {
    console.log("ddn't validate")
    return;
  }

  setLoading(true);

  try {
    console.log("Form Data to Submit:", formData);
console.log("Form Errors:", errors);
console.log("Is Form Valid?", validateForm());
    const submitData = {
      firstName: formData.firstName,
      lastName: formData.lastName || '', // Handle optional field
      mobileNumber: formData.mobileNumber,
      email: formData.email || null, // Send null if empty
      password: formData.password,
      providerTypeIds: formData.providerTypeIds, // Make sure this is an array
      countryCode: formData.countryCode,
      address: formData.address
    };

    console.log("Submitting data:", submitData);

    // Call the actual API
    const response = await createaccountsfromadminaccount(submitData);
    console.log("API Response:", response);

    // Use the actual API response
    setSnackbar({
      open: true,
      message: response.message || 'Provider created successfully.',
      severity: 'success',
    });

    // Clear form on success
    setFormData({
      firstName: '',
      lastName: '',
      mobileNumber: '',
      email: '',
      password: '',
      confirmPassword: '',
      providerTypeIds: [],
      countryCode: '+1',
      address: {
        street: '',
        city: '',
        state: '',
        postalCode: '',
        latitude: '',
        longitude: '',
      },
    });

  } catch (error) {
    console.error("Error creating account:", error);
    
    // Check if it's a validation error from the form
    if (Object.keys(errors).length > 0) {
      setSnackbar({
        open: true,
        message: 'Please fix the form errors before submitting.',
        severity: 'error',
      });
    } else {
      // Show API error
      setSnackbar({
        open: true,
        message: error.message || 'Failed to create account. Please try again.',
        severity: 'error',
      });
    }
  } finally {
    setLoading(false);
  }
};




  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper
        elevation={isMobile ? 0 : 3}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          backgroundColor: isMobile ? 'transparent' : 'background.paper',
        }}
      >
        <Typography
          variant={isMobile ? "h5" : "h4"}
          component="h1"
          gutterBottom
          align="center"
          sx={{ fontWeight: 'bold', mb: 4 }}
        >
          Create New Provider Account
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/* Personal Information */}
            <Grid item xs={12}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                    Personal Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="First Name *"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        error={!!errors.firstName}
                        helperText={errors.firstName}
                        size={isMobile ? "small" : "medium"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Last Name"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        size={isMobile ? "small" : "medium"}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Contact Information */}
            <Grid item xs={12}>
              <Card variant="outlined">
                <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                        Contact Information
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <FormControl fullWidth error={!!errors.countryCode} size={isMobile ? "small" : "medium"}>
                            <InputLabel>Country Code *</InputLabel>
                            <Select
                              name="countryCode"
                              value={formData.countryCode}
                              onChange={handleInputChange}
                              label="Country Code *"
                            >
                              {COUNTRY_CODES.map((country) => (
                                <MenuItem key={country.code} value={country.code}>
                                  {country.code} ({country.country})
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.countryCode && (
                              <Typography variant="caption" color="error">
                                {errors.countryCode}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={9}>
                          <TextField
                            fullWidth
                            label="Mobile Number *"
                            name="mobileNumber"
                            value={formData.mobileNumber}
                            onChange={handleInputChange}
                            error={!!errors.mobileNumber}
                            helperText={errors.mobileNumber}
                            size={isMobile ? "small" : "medium"}
                            type="tel"
                            inputProps={{
                              maxLength: 10, // Limits input to 10 characters
                              pattern: "[0-9]*" // Only allows numbers
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Email (Optional)"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            error={!!errors.email}
                            helperText={errors.email}
                            size={isMobile ? "small" : "medium"}
                            type="email"
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
              </Card>
            </Grid>

            {/* Security Information */}
            <Grid item xs={12}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                    Security Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Password *"
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        value={formData.password}
                        onChange={handleInputChange}
                        error={!!errors.password}
                        helperText={errors.password}
                        size={isMobile ? "small" : "medium"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Confirm Password *"
                        name="confirmPassword"
                        type={showConfirmPassword ? 'text' : 'password'}
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        error={!!errors.confirmPassword}
                        helperText={errors.confirmPassword}
                        size={isMobile ? "small" : "medium"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                edge="end"
                              >
                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Provider Types */}
            <Grid item xs={12}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                    Provider Types *
                  </Typography>
             <FormControl fullWidth error={!!errors.providerTypeIds} size={isMobile ? "small" : "medium"}>
  <InputLabel>Select Provider Type *</InputLabel>
  <Select
    name="providerTypeIds"
    value={formData.providerTypeIds.length > 0 ? formData.providerTypeIds[0] : ''}
    onChange={(e) => {
      setFormData(prev => ({
        ...prev,
        providerTypeIds: [e.target.value] 
      }));
    }}
    label="Select Provider Type *"
  >
    <MenuItem value="">
      <em>Select a provider type</em>
    </MenuItem>
    {Object.values(PROVIDER_TYPES).map((provider) => (
      <MenuItem key={provider.id} value={provider.id}>
        {provider.label}
      </MenuItem>
    ))}
  </Select>
  {errors.providerTypeIds && (
    <Typography variant="caption" color="error">
      {errors.providerTypeIds}
    </Typography>
  )}
</FormControl>
                </CardContent>
              </Card>
            </Grid>

            {/* Address Information */}
            <Grid item xs={12}>
              <Card variant="outlined">
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" sx={{ color: 'primary.main' }}>
                      Address Information
                    </Typography>
                    <Button
                      startIcon={<LocationOn />}
                      onClick={handleGetCurrentLocation}
                      disabled={loading}
                      variant="outlined"
                      size={isMobile ? "small" : "medium"}
                    >
                      {loading ? 'Getting Location...' : 'Use Current Location'}
                    </Button>
                  </Box>
                  
                  {errors.address && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      {errors.address}
                    </Alert>
                  )}

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Street Address"
                        name="street"
                        value={formData.address.street}
                        onChange={handleAddressChange}
                        size={isMobile ? "small" : "medium"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="City"
                        name="city"
                        value={formData.address.city}
                        onChange={handleAddressChange}
                        size={isMobile ? "small" : "medium"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        fullWidth
                        label="State"
                        name="state"
                        value={formData.address.state}
                        onChange={handleAddressChange}
                        size={isMobile ? "small" : "medium"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        fullWidth
                        label="Postal Code"
                        name="postalCode"
                        value={formData.address.postalCode}
                        onChange={handleAddressChange}
                        size={isMobile ? "small" : "medium"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Latitude *"
                        name="latitude"
                        value={formData.address.latitude}
                        onChange={handleAddressChange}
                        error={!!errors.latitude}
                        helperText={errors.latitude}
                        size={isMobile ? "small" : "medium"}
                        type="number"
                        InputProps={{
                          inputProps: { step: "0.000001" }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Longitude *"
                        name="longitude"
                        value={formData.address.longitude}
                        onChange={handleAddressChange}
                        error={!!errors.longitude}
                        helperText={errors.longitude}
                        size={isMobile ? "small" : "medium"}
                        type="number"
                        InputProps={{
                          inputProps: { step: "0.000001" }
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size={isMobile ? "medium" : "large"}
                  disabled={loading}
                  sx={{
                    minWidth: isMobile ? 120 : 150,
                    py: isMobile ? 1 : 1.5,
                  }}
                >
                  {loading ? (
                    <>
                      <CircularProgress size={24} sx={{ mr: 1 }} />
                      Creating...
                    </>
                  ) : (
                    'Create Account'
                  )}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default AdminsAccountCreationPage;